import { NextPageContext } from 'next';
import { Post } from 'lib/types';
import {
  NETWORKS, redirectTo404, TAG_TYPES,
} from 'lib/constants';
import { imagePostUrl, imageUrl } from 'lib/utils/imageUtils';
import {
  serialize, creditsToText, buildPostPath, postToSlug,
  formatAccountName,
} from 'lib/helpers';
import { PostService } from 'server/api/services/PostServices/post';
import { GondolaHead } from 'components/GondolaHead/GondolaHead';
import { PostDetail } from 'features/PostDetail';
import { toNumber } from 'server/api/services/utils';
import { getCurrentUserFromContext } from 'server/api/services/auth';
import { TeamsProvider } from 'lib/contexts/teamsContext';
import { RolesProvider } from 'lib/contexts/rolesContext';

export const getServerSideProps = async (
  context: NextPageContext,
) => {
  try {
    const currentUser = await getCurrentUserFromContext(context);

    const { postId } = context.query;
    const post = await PostService.asUserId(currentUser?.id).getById(toNumber(postId), true);

    if (!post || (post.deleted && !currentUser?.isAdmin)) {
      return redirectTo404;
    }

    const slug = postToSlug(post);
    if (postId !== slug) {
      return {
        redirect: {
          destination: buildPostPath(post),
          permanent: true,
        },
      };
    }
    return {
      props: {
        post: serialize(post),
      },
    };
  } catch (err) {
    return redirectTo404;
  }
};

interface Props {
  post: Post;
}

const PostDetailPage = ({
  post,
}: Props) => (
  <>
    <GondolaHead
      title={`@${formatAccountName(post.account, post.network, post?.networkAccount?.displayName)} via ${NETWORKS[post.network].title}`}
      description={post.credits.length ? `Credits: ${creditsToText(post.credits).join(', ')}` : post.caption}
      url={`https://gondola.cc${buildPostPath(post)}`}
      image={imagePostUrl(post.thumbnailUrl, { isDead: !post.isLive })}
      cardUrl={imageUrl(post.cardUrl)}
    />
    <TeamsProvider>
      <RolesProvider>
        <PostDetail
          serverSidePost={post}
          tagTypes={[TAG_TYPES.tag, TAG_TYPES.event]}
        />
      </RolesProvider>
    </TeamsProvider>
  </>
);

// eslint-disable-next-line import/no-default-export
export default PostDetailPage;
